export const AUTOMATED_TESTING_CONFIG_COOKIES_KEY =
  'ga-automated-testing-config'
// добавление data-test-id
export const AUTOMATED_TESTING_DATA_TEST_ID = 'dataTestId'
// подтверждение локации пользователем
export const AUTOMATED_TESTING_ADDRESS_CONFIRMED = 'addressConfirmed'
// отключение автопроигрывания главного слайдера
export const AUTOMATED_TESTING_BANNERS_SLIDER = 'bannerAutoplayOff'
